import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Paper, Typography } from '@mui/material';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import { sectionBackgrounds, resolveGradient } from '../../../theme';
function getEmbedUrl(url) {
    if (!url)
        return null;
    const youtubeRegex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
    const youtubeMatch = url.match(youtubeRegex);
    if (youtubeMatch)
        return `https://www.youtube.com/embed/${youtubeMatch[1]}`;
    const vimeoRegex = /vimeo\.com\/(?:.*\/)?(\d+)/;
    const vimeoMatch = url.match(vimeoRegex);
    if (vimeoMatch)
        return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
    return url;
}
const aspectRatios = {
    '16:9': '56.25%',
    '4:3': '75%',
    '21:9': '42.86%',
};
/**
 * VideoEmbed – YouTube/Vimeo embed. Supports label + gradient.
 */
const VideoEmbed = ({ label, gradient, url, title, aspectRatio = '16:9', titleColor, titleFontSize, paddingTop, paddingBottom, paddingLeft, paddingRight, marginTop, marginBottom, maxWidth, width = '100%', borderRadius = 2, boxShadow, border, borderColor, backgroundColor, fontFamily, fontWeight = 700, componentAlignment = 'left', }) => {
    const background = gradient
        ? resolveGradient(gradient, sectionBackgrounds.hero)
        : backgroundColor || 'transparent';
    const embedUrl = getEmbedUrl(url);
    const aspectPaddingBottom = aspectRatios[aspectRatio] || aspectRatios['16:9'];
    return (_jsx(Box, { component: "section", sx: {
            background,
            paddingTop: paddingTop || 3,
            paddingBottom: paddingBottom || 3,
            paddingLeft: paddingLeft || 0,
            paddingRight: paddingRight || 0,
            marginTop: marginTop || 0,
            marginBottom: marginBottom || 0,
            textAlign: componentAlignment,
        }, children: _jsxs(Box, { sx: { maxWidth: maxWidth || 800, mx: 'auto', px: 2 }, children: [label && (_jsx(Typography, { variant: "overline", sx: { display: 'block', mb: 2, color: 'text.secondary', letterSpacing: 1 }, children: label })), title && (_jsx(Typography, { sx: {
                        fontSize: titleFontSize || '1.5rem',
                        fontWeight: Number(fontWeight) || 700,
                        fontFamily: fontFamily || undefined,
                        mb: 2,
                        color: titleColor || 'text.primary',
                    }, children: title })), _jsx(Paper, { sx: {
                        position: 'relative',
                        paddingBottom: aspectPaddingBottom,
                        height: 0,
                        overflow: 'hidden',
                        borderRadius: typeof borderRadius === 'number' ? borderRadius : borderRadius,
                        boxShadow: boxShadow || '0 1px 3px rgba(0,0,0,0.08)',
                        border,
                        borderColor: borderColor || 'divider',
                        width,
                    }, children: embedUrl ? (_jsx("iframe", { src: embedUrl, style: {
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            border: 'none',
                        }, allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true, title: title || 'Video' })) : (_jsxs(Box, { sx: {
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            bgcolor: 'grey.200',
                            color: 'text.secondary',
                        }, children: [_jsx(VideoLibraryIcon, { sx: { fontSize: 64, mb: 2, opacity: 0.5 } }), _jsx(Typography, { variant: "body1", children: "No video URL provided" })] })) })] }) }));
};
export default VideoEmbed;
